"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const directionsData = [{
  label: "環境調整",
  desc1: "環境調整はその人が生活する環境を変化させることによって困り事や悩みを改善していくもので、本人ではなく周囲の変化によって本人の適応状態の向上を目指していきます。",
  desc2: "この方法は困っている状況を改善していきたいけれど、問題を抱えている本人が1人で問題に取り組むことが難しい場合に、周囲の人たちと協力することで状況を改善していく、または問題に取り組める状態をつくっていこうとする時に有効な方法です。"
}, {
  label: "症状改善",
  desc1: "症状改善はうつ気分や不安などの心理状態、問題となっている行動や状況を改善することを主な目的としたもので、相談される方が自身の状態を変えていくことを目指していきます。",
  desc2: "環境調整と比較するなら、この方法は問題を抱えている本人が問題に取り組んでいけることと併せて、変えていこうとする状態や状況が明確である場合に有効な方法です。困っている事柄や改善方法、改善した状態について具体的に取り組んでいきます。"
}, {
  label: "自己探索",
  desc1: "自己探索は問題を明確にしたり自己理解を深めたりすることを目的にしたもので、何かを改善するというよりは、自分自身のよくわからないところを知る、明確にすることを目指していきます。",
  desc2: "カウンセリングを始める時、あるいは進めていく過程であっても、何が自分にとって問題であるのか、自分は何をしたいのかということが明らかでなくなることもあります。自己理解を深めることによって取り組むべき問題や進んでいく方向を明確にしていきます。"
}];
export default function ThreeDirections() {
  return <section id="threedirections" className="bg-background pt-0 pb-16 md:pb-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
      
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">3つの方向性</h2>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <div className="border-t border-border divide-y divide-border">
          {directionsData.map((item, i) => <div key={i} data-index={i} className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-4 md:gap-12 py-8 md:py-10 items-start">
              <h3 className="text-lg md:text-xl font-bold text-primary-heading font-default">{item.label}</h3>
              <div className="space-y-4">
                <p className="text-foreground leading-relaxed font-default">{item.desc1}</p>
                {item.desc2 && <p className="text-foreground leading-relaxed font-default">{item.desc2}</p>}
              </div>
            </div>)}
        </div>

        <p className="mt-10 text-foreground leading-relaxed font-default">当ルームで行っているカウンセリング技法については<Link to="https://yotsuya-sc-room.com/technique/" className="text-primary-heading underline underline-offset-4">こちら</Link>をご参照ください。</p>

      </div>
    </section>;
}